module.exports = __webpack_public_path__ + "img/GAME_MINHWATU2.a2f1a90b.jpg";